module.exports = "pegasus/assets/blocks/column-15-theme5.png";